import { render, staticRenderFns } from "./nav-item-list.vue?vue&type=template&id=71428802&scoped=true&"
import script from "./nav-item-list.vue?vue&type=script&lang=ts&"
export * from "./nav-item-list.vue?vue&type=script&lang=ts&"
import style0 from "./nav-item-list.vue?vue&type=style&index=0&id=71428802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71428802",
  null
  
)

export default component.exports